import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '@shared-angular/services/login.service';
import { BotService } from '../services/bot.service';

export const botprotect: CanActivateFn = async (route, _state) => {
  const router = inject(Router);
  const loginService: LoginService = inject(LoginService);
  const botService: BotService = inject(BotService);


  // persist=false: Token wird erst nach Bestaetigung des Datenschutzhinweises in BotBasedComponent persistiert
  const user = await loginService.loadMyUser(false);
  if (user == null) {
    return false;
  }
  const id = route.params['id'] as string;
  const botConfig = await botService.getBotConfigAsUser(id);
  if (botConfig == null) {
    return router.createUrlTree(['/403']);
  }

  let origin: string = '';
  if (botConfig.isPwProtected) {
    if (route.url[2]) origin = route.url[2].path;
    const passthroughToken = localStorage.getItem("passthrough") ?? '';
    if (passthroughToken === '') {
      void router.navigate(['botlogin', id, origin], { queryParams: route.queryParams });
      return false;
    } else if (passthroughToken !== id) {
      void router.navigate(['botlogin', id, origin], { queryParams: route.queryParams });
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};
